import { render, staticRenderFns } from "./messageSheet.vue?vue&type=template&id=36cb1042&scoped=true&lang=pug"
import script from "./messageSheet.vue?vue&type=script&lang=js"
export * from "./messageSheet.vue?vue&type=script&lang=js"
import style0 from "./messageSheet.vue?vue&type=style&index=0&id=36cb1042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb1042",
  null
  
)

export default component.exports